import './BookmarkPanel.scss';

export { default } from './BookmarkPanel';
